import React, { useRef, useState, useEffect, useMemo, useCallback } from "react";
// filepath: c:\Users\46730\my-site\src\ProjectsVersion4.js
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import ImageViewer from "./components/ImageViewer";




// === PROJECT DATA: Each project now has 'introText' and 'introImage' fields ===
const projects = [
  {
    title: "",
    image: "/hgr.png",
    repoOwner: "primate686293297679030",
  repoName: "HamraGrodor",
    defaultBranch: "main",
    description: "Unity, LIA, phone/touchpad game, solodev",
    itchioUrl: null, // No itch.io link for this project
    introText: [
      "This project was organized only within Unitys UI framework",
      "The game is responsive to diffrent screensizes on e.g. mobile-devices  ",
      "It has a save function for your different scores, by using unityprefs",
      "It has 8 buffs 4 negative and 4 positive.",
      "The sun is enhanced with a shader",
      "It contains animations that mostly utilize the DOtween library except the bubble-animation.",
      
    ],
    
    introImage: "/project1-header.jpg", // Optional, can be omitted
    presentations: [
        
      {
        videoSrc: "/MyVideo_6(1).mp4",
        label: "HGR Gameplay",


      },
      {
        videoSrc: "/MyVideo_12.mp4",
        label: "PulsatingTouch",
        introText:[
        "Pulsatingtouch in action",
        "smashing mulitple frogs with a chain-reaction like mechaninc."
        ,
        "the function is async only because delaying time is more quality of life by using an awaitable instead of a coroutine. not doing an actual async workflow"

        ],
        codeFiles: [
          {
            githubFilePath: "Assets/Scripts/GameManager.cs",
            githubLine: "324-373",
            language: "csharp",
            label: "Buff effect logic for PulsatingTouch"
          }
        ]
      },
      {
        videoSrc: "/MyVideo_13.mp4",
        label: "BubbleAnimation",
                introText:[
        "Transitioning-to-the-settings animation"

        ],
        codeFiles: [
          
    
          {
            githubFilePath: "Assets/Scripts/Animations/BubbleManager.cs",
            githubLine: "1-290",
            language: "csharp",
            label: "BubbleManager.cs (Lines 1-290)"
          }
        ]
      }
  
    ]
  },
    {
    title: "",
    repoOwner: "primate686293297679030",
    repoName: "spaceshooter-ECS",
    defaultBranch: "main",
    image: "/spaceshooter-thumb.png",
    description: "spaceshooter-ECS, Unity, performance, solodev",
    itchioUrl: null, // No itch.io link for this project
    introText: [
      "This was a space shooter made with Unity DOTS ",
      "I got to practise using the profiler in untiy to optimize my code."
      
    ],
    presentations: [
      {
        imageSrc: "/ecs.png",
        label: "Entity Collision System",
        codeFiles: [
          {
            githubFilePath: "spaceshooter/Assets/EntityCollision.cs",
            githubLine: "1-50", // Adjust as needed to a real line range
            language: "csharp",
            label: "Collision management"
          }
        ]
      }
    ]
  },
  {
    title: "",
    image: "_Z75OQ.png",
    description: "Unity, gameplay programming, Team project",
    itchioUrl: "https://futuregames.itch.io/packup-and-leaf",
    introText: [
      "Fantastic game project at Futuregames",
      "I hooked up a gameplay mechanic together with the game loop ",
      "It made the player able to pick up leaves and berries",
      "get score and audio feedback",
      "OnPickup event is raised for triggering other related functionality",
      " like the animation for displaying the score and such",

      
    ],
    // introImage: "/project2-header.jpg", // You can add this if you have an image
    presentations: [
      {
        videoSrc: "/PickingUpLeafs.mp4",
        label: "Gameplay mechanic: Pick Up",
        codeFiles: [
          {
            language: "csharp",
            prerenderedSrc: "/prerendered-code/LerpToPlayer.html",
            label: "Move leaf or berry to player"
          },
          {
            language: "csharp",
            prerenderedSrc: "/prerendered-code/PickUpRange.html",
            label: "Ranged based trigger for pickup"
          }
        ]
      }
    ]
  },
  {
    title: "",
    image: "/11hQRA.png",
    description: "UE4, gameplay programming, Team project",
    itchioUrl: "https://futuregames.itch.io/carnage-at-castle-moon",
    introText: [
      "Gameproject 3 at futuregames",
      "In this project i coded gun logic and a wavemanager",
     "In the first picture you can see the spawnpoints (small red dots). ",
      "HeartSpawnpoint property in WaveManager.h (green text color) is used for attaching spawnpoints to a certain heart eg. heart1 or heart2 ",
      "So enemies spawning from that spawnpoint will target that specific heart",
      "There are more editor properties that will be self explanatory when you skim through",
    ],
    // introImage: "/project2-header.jpg", // You can add this if you have an image
    presentations: [
      {
        imageSrc: "/CarnageAtCastleMoon-Map.png",
        label: "Spawn Points",
        codeFiles: [
          {
            language: "cpp",
            prerenderedSrc: "/prerendered-code/WaveManager.html",
            label: "WaveManager.cpp"
          },
          {
            language: "cpp",
            prerenderedSrc: "/prerendered-code/WaveManagerh.html",
            label: "WaveManager.h"
          }
        ]
      },
      {
        videoSrc: "/CaCMSpawning.mp4",
        label: "Spawning",
             introText: [
      "HeartComponent just signals when the heart is attacked",

        ],
      codeFiles: [
           {
            language: "cpp",
            prerenderedSrc: "/prerendered-code/HeartComponentcpp.html",
            label: "HeartComponent.cpp"
          },
          {
            language: "cpp",
            prerenderedSrc: "/prerendered-code/HeartComponenth.html",
            label: "HeartComponent.h"
          }

        ]
      },
      {
        videoSrc: "/CacMgun.mp4",
        label: "Gun",
                    introText: [
      "Gun uses raytracing with a range limit, if it hits and enemy it will apply damage to it",
      "It has an autofire toggle and the rest is mostly just integration with sound and graphics",

        ],
       codeFiles: [
          {
            language: "cpp",
            prerenderedSrc: "/prerendered-code/GunInputcpp.html",
            label: "GunInputcpp.cpp"
          },
          {
            language: "cpp",
            prerenderedSrc: "/prerendered-code/GunInputh.html",
            label: "GunInputh.h "
          }
        ]
      }

    ]
  },
  {
    title: "",
    image: "/swa_UZ.png",
    description: "UE5, blueprints, Team project",
    itchioUrl: "https://futuregames.itch.io/smol",
    introText: [
      "Gameproject 4 at futuregames",
      "The theme for this project circulated around physics.",
      "This was my most productive game project and i remember being of good help to the team",
      "The magnet gun was my main assignment which i implemented in blueprints"
    ],
    presentations: [
      {
        videoSrc: "/SMOL.mp4",
        label: "MagnetGun Gameplay",
        component: "blueprint",
        blueprintSrc: "/magnet-gun-blueprint.png",
        introText: [
      "Gameproject 4 at futuregames",
      "The theme for this project circulated around physics.",
      "This was my most productive game project and i remember being of good help to the team",
      "The magnet gun was my main assignment which i implemented in blueprints"
        ]
      }
            ,
            {
        videoSrc: "/prototyping.mp4",
        label: "pulling force ",
        introText: [
          "This is early prototype footage showing the pulling force mechanics",
          "Your able to use this as a slingshot mechanic in the game by turning off the forcefield",
  
        ]
        
      }
    ]
  },

];

// --- Utility functions ---
function getGitHubBlobUrl({ githubFilePath, githubLine, repoOwner, repoName, defaultBranch }) {
  if (!githubFilePath) return null;
  let url = `https://github.com/${repoOwner}/${repoName}/blob/${defaultBranch}/${githubFilePath}`;
  if (githubLine) {
    if (typeof githubLine === "number" || /^\d+$/.test(githubLine)) {
      url += `#L${githubLine}`;
    } else if (typeof githubLine === "string" && /^\d+-\d+$/.test(githubLine)) {
      const [start, end] = githubLine.split("-");
      url += `#L${start}-L${end}`;
    }
  }
  return url;
}
function getRawGitHubUrl({ repoOwner, repoName, defaultBranch, githubFilePath }) {
  if (!githubFilePath) return null;
  return `https://raw.githubusercontent.com/${repoOwner}/${repoName}/${defaultBranch}/${githubFilePath}`;
}
function getLinesFromCode(code, start, end) {
  const lines = code.split('\n');
  return lines.slice(start - 1, end).join('\n');
}

// Global cache for code snippets to prevent re-fetching
const codeCache = new Map();

// --- Project Presentation Card ---
function ProjectPresentation({ project, onBack }) {
  const [presentationIndex, setPresentationIndex] = useState(0);
  const [codeIndex, setCodeIndex] = useState(0);
  const [allCodeSnippets, setAllCodeSnippets] = useState({});
  const [allCodeErrors, setAllCodeErrors] = useState({});
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLooping, setIsLooping] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const videoRefs = useRef({});
  const codeBlockRef = useRef(null);
  const presentation = project.presentations[presentationIndex];
  const codeFiles = useMemo(() => (Array.isArray(presentation.codeFiles) 
    ? presentation.codeFiles : []), [presentation.codeFiles]);

  // Preload ALL code files from ALL presentations when component mounts
  useEffect(() => {
    const loadAllCode = async () => {
      setIsLoading(true);
      // Initialize state for all presentations at once
      const newAllCodeSnippets = {};
      const newAllCodeErrors = {};

      // Batch all promises for parallel loading
      const loadPromises = [];

      for (let presIndex = 0; presIndex < project.presentations.length; presIndex++) {
        const pres = project.presentations[presIndex];
        const presCodeFiles = Array.isArray(pres.codeFiles) ? pres.codeFiles : [];
        
        newAllCodeSnippets[presIndex] = Array(presCodeFiles.length).fill("");
        newAllCodeErrors[presIndex] = Array(presCodeFiles.length).fill(null);

        // Create promises for each code file
        presCodeFiles.forEach((codeMeta, codeFileIndex) => {
          
          if (codeMeta.prerenderedSrc) {
            // Check cache first for pre-rendered files
            if (codeCache.has(codeMeta.prerenderedSrc)) {
              const cachedData = codeCache.get(codeMeta.prerenderedSrc);
              if (cachedData.error) {
                newAllCodeErrors[presIndex][codeFileIndex] = cachedData.error;
              } else {
                newAllCodeSnippets[presIndex][codeFileIndex] = cachedData.html;
              }
              return;
            }

            loadPromises.push(
              fetch(codeMeta.prerenderedSrc)
                .then(res => {
                  if (!res.ok) throw new Error("Pre-rendered file not found.");
                  return res.text();
                })
                .then(html => {
                  // Cache the result
                  codeCache.set(codeMeta.prerenderedSrc, { html });
                  newAllCodeSnippets[presIndex][codeFileIndex] = html;
                })
                .catch(err => {
                  // Cache the error
                  codeCache.set(codeMeta.prerenderedSrc, { error: err.message });
                  newAllCodeErrors[presIndex][codeFileIndex] = err.message;
                })
            );
          } else if (codeMeta.localFileSrc) {
            // Check cache first
            if (codeCache.has(codeMeta.localFileSrc)) {
              const cachedData = codeCache.get(codeMeta.localFileSrc);
              if (cachedData.error) {
                newAllCodeErrors[presIndex][codeFileIndex] = cachedData.error;
              } else {
                newAllCodeSnippets[presIndex][codeFileIndex] = cachedData.text;
              }
              return;
            }

            loadPromises.push(
              fetch(codeMeta.localFileSrc)
                .then(res => {
                  if (!res.ok) throw new Error("File not found.");
                  return res.text();
                })
                .then(text => {
                  // Cache the result
                  codeCache.set(codeMeta.localFileSrc, { text });
                  newAllCodeSnippets[presIndex][codeFileIndex] = text;
                })
                .catch(err => {
                  // Cache the error
                  codeCache.set(codeMeta.localFileSrc, { error: err.message });
                  newAllCodeErrors[presIndex][codeFileIndex] = err.message;
                })
            );
          } else if (codeMeta.githubFilePath && project.repoOwner) {
            const url = getRawGitHubUrl({
              repoOwner: project.repoOwner,
              repoName: project.repoName,
              defaultBranch: project.defaultBranch,
              githubFilePath: codeMeta.githubFilePath,
            });

            // Check cache first
            if (codeCache.has(url)) {
              const cachedData = codeCache.get(url);
              if (cachedData.error) {
                newAllCodeErrors[presIndex][codeFileIndex] = cachedData.error;
              } else {
                newAllCodeSnippets[presIndex][codeFileIndex] = cachedData.text;
              }
              return;
            }

            loadPromises.push(
              fetch(url)
                .then(res => {
                  if (!res.ok) throw new Error("Code file not found on GitHub.");
                  return res.text();
                })
                .then(text => {
                  // Cache the result
                  codeCache.set(url, { text });
                  newAllCodeSnippets[presIndex][codeFileIndex] = text;
                })
                .catch(err => {
                  // Cache the error
                  codeCache.set(url, { error: err.message });
                  newAllCodeErrors[presIndex][codeFileIndex] = err.message;
                })
            );
          }
        });
      }

      // Wait for all files to load, then update state once
      await Promise.allSettled(loadPromises);
      
      setAllCodeSnippets(newAllCodeSnippets);
      setAllCodeErrors(newAllCodeErrors);
      setIsLoading(false);
    };

    loadAllCode();
  }, [project.title, project.repoOwner, project.repoName, project.defaultBranch, project.presentations]);

  // Reset code index when presentation changes, but don't reload everything
  useEffect(() => {
    setCodeIndex(0);
    if (codeBlockRef.current) {
      codeBlockRef.current.scrollTop = 0;
    }
  }, [presentationIndex]);


  // Reset scroll when code index changes
  useEffect(() => {
    if (codeBlockRef.current) {
      codeBlockRef.current.scrollTop = 0;
    }
  }, [codeIndex]);

  // Video handlers - now work with current video only
  const getCurrentVideo = useCallback(() => {
    return videoRefs.current[presentationIndex];
  }, [presentationIndex]);

  const handlePlayPause = () => {
    const currentVideo = getCurrentVideo();
    if (!currentVideo) return;
    if (isPlaying) {
      currentVideo.pause();
    } else {
      currentVideo.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleLoop = () => {
    const currentVideo = getCurrentVideo();
    if (!currentVideo) return;
    const newLoop = !isLooping;
    currentVideo.loop = newLoop;
    setIsLooping(newLoop);
  };

  const handleVideoPlay = () => setIsPlaying(true);
  const handleVideoPause = () => setIsPlaying(false);

  const nextCode = () => setCodeIndex((i) => (i + 1) % codeFiles.length);
  const prevCode = () => setCodeIndex((i) => (i - 1 + codeFiles.length) % codeFiles.length);

  // Debounced navigation to prevent rapid state updates
  const handlePresentationChange = useCallback((newIndex) => {
    const currentVideo = getCurrentVideo();
    if (currentVideo) {
      currentVideo.pause();
      setIsPlaying(false);
    }
    setPresentationIndex(newIndex);
  }, [getCurrentVideo]);

  // Get current code data - memoized for performance
  const { codeToShow, startLine, currentGitHubBlobUrl, currentError, isPrerendered } = useMemo(() => {
    const currentCodeMeta = codeFiles[codeIndex] || {};
    const currentSnippets = allCodeSnippets[presentationIndex] || [];
    const currentErrors = allCodeErrors[presentationIndex] || [];
    
    let code = "";
    let isPrerenderedHtml = !!currentCodeMeta.prerenderedSrc;
    
    if (isPrerenderedHtml) {
      // For pre-rendered files, we don't need to process the code
      code = "Pre-rendered content";
    } else if (currentCodeMeta.code) {
      code = currentCodeMeta.code.trim();
    } else {
      code = currentSnippets[codeIndex] || "// Loading code…";
    }

    let lineStart = 1;
    if (!isPrerenderedHtml && typeof currentCodeMeta.githubLine === "string" && /^\d+-\d+$/.test(currentCodeMeta.githubLine)) {
      const [start, end] = currentCodeMeta.githubLine.split("-").map(Number);
      code = getLinesFromCode(code, start, end);
      lineStart = start;
    } else if (!isPrerenderedHtml && (typeof currentCodeMeta.githubLine === "number" || /^\d+$/.test(currentCodeMeta.githubLine))) {
      const line = Number(currentCodeMeta.githubLine);
      code = getLinesFromCode(code, line, line);
      lineStart = line;
    }

    const gitHubUrl = project.repoOwner
      ? getGitHubBlobUrl({
          githubFilePath: currentCodeMeta.githubFilePath,
          githubLine: currentCodeMeta.githubLine,
          repoOwner: project.repoOwner,
          repoName: project.repoName,
          defaultBranch: project.defaultBranch,
        })
      : null;

    return {
      codeToShow: code,
      startLine: lineStart,
      currentGitHubBlobUrl: gitHubUrl,
      currentError: currentErrors[codeIndex],
      isPrerendered: isPrerenderedHtml
    };
  }, [codeFiles, codeIndex, allCodeSnippets, presentationIndex, allCodeErrors, project.repoOwner, project.repoName, project.defaultBranch]);

  // Get current presentation intro text - either from presentation or project fallback
  const getCurrentIntroText = () => {
    const currentPresentation = project.presentations[presentationIndex];
    return currentPresentation?.introText || project.introText;
  };

  return (
    <>
      <style>{`
        .prerendered-code {
          background: #282c34 !important;
          border-radius: 8px;
          overflow: auto;
        }
        .prerendered-code iframe {
          width: 100%;
          height: 100%;
          border: none;
          background: #282c34;
        }
        .prerendered-code pre {
          margin: 0 !important;
          padding: 16px !important;
          background: #282c34 !important;
          color: #abb2bf !important;
          font-family: Consolas, Monaco, 'Courier New', monospace !important;
          font-size: 1.08em !important;
          line-height: 1.5 !important;
          border-radius: 8px !important;
          overflow: auto !important;
          white-space: pre-wrap !important;
        }
        .prerendered-code code {
          background: transparent !important;
          color: inherit !important;
          font-family: inherit !important;
          font-size: inherit !important;
        }
        .prerendered-code * {
          font-family: Consolas, Monaco, 'Courier New', monospace !important;
        }
      `}</style>
      <div className="project-details-wrapper" style={{
      maxWidth: "1600px",
      margin: "0 auto",
      background: "#302c3a",
      minHeight: "100vh",
      boxSizing: "border-box"
    }}>
      <div
        className="video-card"
        style={{
          background: "#23272e",
          borderRadius: "14px",
          boxShadow: "0 2px 24px #0008",
          width: "100%",
          maxWidth: "100%",
          margin: "0 auto",
          padding: 0,
          position: "relative"
        }}
      >
        <button
          onClick={onBack}
          style={{
            margin: "24px 0 0 24px",
            padding: "8px 18px",
            borderRadius: "8px",
            background: "#272822",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            fontSize: "1.05em",
            fontWeight: "bold",
            boxShadow: "0 1px 4px #0002",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 2
          }}
        >
          &larr; Back to projects
        </button>

        {/* Itch.io link positioned on the right */}
        {project.itchioUrl && (
          <a
            href={project.itchioUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              margin: "24px 24px 0 0",
              padding: "8px 18px",
              borderRadius: "8px",
              background: "#fa5c5c",
              color: "#fff",
              textDecoration: "none",
              fontSize: "1.05em",
              fontWeight: "bold",
              boxShadow: "0 1px 4px #0002",
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 2,
              display: "flex",
              alignItems: "center",
              gap: "6px"
            }}
          >
            itch.io ↗
          </a>
        )}

        {/* --- Intro Section: SHOWN ABOVE VIDEO PREVIEW --- */}
        {(getCurrentIntroText() || project.introImage) && (
          <div className="projectstext" style={{ padding: "72px 24px 0 24px", textAlign: "center" }}>
            {project.introImage && (
              <img
                src={project.introImage}
                alt={project.title + " header"}
                style={{ maxWidth: 280, borderRadius: 10, marginBottom: 12 }}
              />
            )}
            {getCurrentIntroText() && (
              <div className="projectstext" style={{ color: "white", marginBottom: 12, textAlign: "center" }}>
                {Array.isArray(getCurrentIntroText())
                  ? getCurrentIntroText().map((para, idx) => (
                      <p key={idx}>{para}</p>
                    ))
                  : <div>{getCurrentIntroText()}</div>
                }
              </div>
            )}
          </div>
        )}

        {/* Top bar with label only */}
        <div
          className="video-top-bar"
          style={{
            background: "#23272e",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px 24px",
            fontSize: "1.1em"
          }}
        >
          <span style={{ color: "#fff" }}>
            <b>{project.title}</b>
            <span style={{ color: "#b2b2b2", fontWeight: 400, fontSize: "0.95em" }}>&nbsp;&ndash;&nbsp;{presentation.label}</span>
          </span>
        </div>

        {/* Media - render all videos/images but show only current one */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", background: "#23272e" }}>
          {project.presentations.map((pres, idx) => (
            <div key={idx} style={{ display: idx === presentationIndex ? "block" : "none" }}>
              {pres.videoSrc && (
                <video
                  ref={el => videoRefs.current[idx] = el}
                  width="640"
                  height="360"
                  src={pres.videoSrc}
                  controls={false}
                  loop={isLooping}
                  preload="metadata"
                  onPlay={handleVideoPlay}
                  onPause={handleVideoPause}
                  style={{ borderRadius: "10px", margin: "24px 0 0 0", boxShadow: "0 2px 8px #0005" }}
                />
              )}
              {pres.imageSrc && (
                <img
                  src={pres.imageSrc}
                  alt={pres.label}
                  width="640"
                  height="360"
                  style={{ borderRadius: "10px", margin: "24px 0 0 0", boxShadow: "0 2px 8px #0005", objectFit: "cover" }}
                />
              )}
            </div>
          ))}
          
          {/* Navigation arrows below media */}
          {project.presentations.length > 1 && (
            <div style={{ display: "flex", alignItems: "center", gap: "24px", margin: "16px 0 0 0" }}>
              <button
                onClick={() => handlePresentationChange((presentationIndex - 1 + project.presentations.length) % project.presentations.length)}
                style={{ fontSize: "1.5em", background: "none", border: "none", color: "#fff", cursor: "pointer" }}
                aria-label="Previous presentation"
              >&larr;</button>
              <span style={{ color: "#b2b2b2", fontSize: "0.9em" }}>
                {presentationIndex + 1} / {project.presentations.length}
              </span>
              <button
                onClick={() => handlePresentationChange((presentationIndex + 1) % project.presentations.length)}
                style={{ fontSize: "1.5em", background: "none", border: "none", color: "#fff", cursor: "pointer" }}
                aria-label="Next presentation"
              >&rarr;</button>
            </div>
          )}
        </div>
        
        {/* Video/Code Control Bar */}
        <div className="video-bottom-bar" style={{ background: "#23272e", borderBottomLeftRadius: "14px", borderBottomRightRadius: "14px",  display: "flex", alignItems: "center", justifyContent: "center", gap: "24px", padding: "14px 0", fontSize: "1.05em" }}>
          {presentation.videoSrc && (
            <>
              <button onClick={handlePlayPause}>{isPlaying ? "Pause" : "Play"}</button>
              <button onClick={handleLoop}>{isLooping ? "Loop: On" : "Loop: Off"}</button>
            </>
          )}
        </div>

        {/* Blueprint viewer: Always shown for blueprint presentations */}
        {presentation.component === "blueprint" && presentation.blueprintSrc && (
          <div
            className="blueprint-block"
            style={{
              width: "100%",
              maxWidth: "1600px",
              margin: "18px auto 0 auto",
              background: "#23272e",
              boxShadow: "0 2px 6px #0003",
              padding: "18px",
              minHeight: "400px",
              overflow: "auto"
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "1600px",
                margin: "0 auto"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "12px"
                }}
              >
                <span style={{ fontSize: "1em", color: "#b2b2b2" }}>
                  MagnetGun Blueprint 
                </span>
              </div>

              <div
                style={{
                  width: "100%",
                  minHeight: "400px",
                  background: "#23272e",
                  borderRadius: "8px"
                }}
              >
                <ImageViewer 
                  src={presentation.blueprintSrc}
                  alt="Blueprint Design"
                  className="blueprint-viewer"
                />
              </div>
            </div>
          </div>
        )}

        {/* Code block: Always shown */}
        {Array.isArray(codeFiles) && codeFiles.length > 0 && codeFiles[codeIndex] && (
          <div
            ref={codeBlockRef}
            className="code-block"
            style={{
              width: "100%",
              maxWidth: "1600px",
              margin: "18px auto 0 auto",
              background: "#23272e",
              boxShadow: "0 2px 6px #0003",
              padding: "18px",
              minHeight: "300px",
              overflow: "auto"
            }}
          >
            {isLoading && (
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                minHeight: "200px",
                color: "#b2b2b2" 
              }}>
                Loading code files...
              </div>
            )}
            
            <div
              style={{
                width: "100%",
                maxWidth: "1600px",
                margin: "0 auto",
                opacity: isLoading ? 0.5 : 1,
                transition: "opacity 0.3s ease"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "6px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {codeFiles.length > 1 && (
                    <>
                      <button onClick={prevCode} style={{ fontSize: "1.15em" }} disabled={isLoading}>&larr;</button>
                      <span style={{ margin: "0 8px" }}>
                        {codeIndex + 1} / {codeFiles.length}
                      </span>
                      <button onClick={nextCode} style={{ fontSize: "1.15em" }} disabled={isLoading}>&rarr;</button>
                    </>
                  )}
                  <span style={{ marginLeft: 12, fontSize: "1em", color: "#b2b2b2" }}>
                    {(codeFiles[codeIndex] || {}).label}
                  </span>
                </div>
                {currentGitHubBlobUrl && (
                  <a
                    href={currentGitHubBlobUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#4078c0",
                      textDecoration: "underline",
                      fontWeight: "bold",
                      fontSize: "1em"
                    }}
                  >
                    View on GitHub
                  </a>
                )}
              </div>

              {currentError && (
                <div style={{ color: "red", marginBottom: 8 }}>
                  {currentError}
                </div>
              )}

              <div
                style={{
                  width: "100%",
                  minHeight: "300px",
                  background: "#23272e",
                }}
              >
                {!isLoading && (
                  isPrerendered ? (
                    <iframe
                      src={codeFiles[codeIndex]?.prerenderedSrc}
                      style={{
                        width: "100%",
                        minHeight: "500px",
                        border: "none",
                        background: "#282c34",
                        borderRadius: "8px"
                      }}
                      title={`Code: ${(codeFiles[codeIndex] || {}).label}`}
                    />
                  ) : (
                    <SyntaxHighlighter
                      language={(codeFiles[codeIndex] || {}).language || "csharp"}
                      style={oneDark}
                      wrapLongLines={true}
                      showLineNumbers
                      startingLineNumber={startLine}
                      customStyle={{
                        fontSize: "1.08em",
                        background: "none",
                        margin: 0,
                        height: "100%",
                        minHeight: "100%"
                      }}
                    >
                      {codeToShow}
                    </SyntaxHighlighter>
                  )
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
    </>
  );
}

// --- Main Projects Menu ---
const Projects = () => {
    useEffect(() => {
    document.title = "Simon Liljedahl";
  }, []); // Empty dependency array means this runs once on mount

  const [selectedProjectIndex, setSelectedProjectIndex] = useState(null);
  useEffect(() => {
  if (selectedProjectIndex !== null) {
    document.body.classList.add("project-open");
  } else {
    document.body.classList.remove("project-open");
  }
  }, [selectedProjectIndex]);

  return (
    <>
      {/* Overlay for project details, rendered outside .page-center */}
     {selectedProjectIndex !== null ? (
  <div className="project-details-wrapper">
    <ProjectPresentation
      project={projects[selectedProjectIndex]}
      onBack={() => setSelectedProjectIndex(null)}
    />
  </div>
) : (

       <div className="content" style={{ minHeight: "200vh" }}>
        <div className="container, h2" style={{ fontFamily: 'libmonoreg', textAlign: "center",  }}>
          <section className="projects-description">
            <p>
              <br />
              <br />
              These project-cards contains descriptions, graphics and code snippets.
              <br />
              For learning about the project  <br />
              give visual feedback<br />
              and show how I implemented it <br />
              Check out the cover letter in the CV section for more complementary information.<br />
              <br />
     
            </p>
          </section>
        </div>
        <div
          className="projects-menu"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "32px",
            justifyContent: "center",
            padding: "32px 0",
            maxWidth: "1100px",
            margin: "0 auto"
          }}
        >
          {projects.map((proj, idx) => (
            <div
              key={idx}
              className="project-thumb-card"
style={{
  width: 320,
  padding: 0,
  textAlign: "center",
  cursor: "pointer",
  background: "none",
  border: "none",
  boxShadow: "none",
  borderRadius: 0,
  transition: "transform 0.15s"
}}
              onClick={() => setSelectedProjectIndex(idx)}
            >
              <div style={{ fontWeight: "bold", color: "#fff", fontSize: "1.22em", marginBottom: 12 }}>{proj.title}</div>
<img
  src={proj.image}
  alt={proj.title + " thumbnail"}
  style={{
    width: "100%",
    height: 190,
    objectFit: "contain", // fits the whole image, may show background
    background: "#2d3142",   // optional: background color for letterbox
    marginBottom: 14
  }}
/>
              <div style={{ color: "#b2b2b2", fontSize: "1em", minHeight: 54 }}>{proj.description}</div>
            </div>
          ))}
        </div>
      </div>
      )}

      {/* The grid and rest of the page */}
 
    </>
  );
  
};
export default Projects;